import { getRenderer, SingleSelectWithOptionStore } from "csi/components/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { C8FieldType, VALUE_TYPE } from "src/c8-platform/type/value";
import { useAttributeDefinitionStore } from "./AttributeDefinitionStore";
import { RendererProps } from "csi/components/RendererRegistry";

const AttributeDefinitionSectionInitialValue: FunctionComponent = observer(() => {
	const { 
		attrEnumInitialValue,
		attrFormat,
		attrInitialValue,
		attrInitialValueError,
		attrType,
		enumValueDataStore,
		initialValueHidden,
		locale,
		onChangeEnumInitialValue,
		onChangeInitialValue,
	} = useAttributeDefinitionStore();
	const {
		labelInitialValue,
		labelInitialValueRes,
		helperTextAttributeDefinitionHasInitialValue,
	} = locale;

	const error = !!attrInitialValueError;

	if (initialValueHidden) {
		return;
	} else if (enumValueDataStore) {
		// TODO: is helperText supported for single select?
		return (
			<SingleSelectWithOptionStore
				disableClearable={false}
				error={error}
				errorMessage={attrInitialValueError}
				labelRes={labelInitialValueRes}
				onChange={onChangeEnumInitialValue}
				optionsStore={enumValueDataStore}
				value={attrEnumInitialValue}
			/>
		);
	}
	
	const Component = getRenderer(attrType as C8FieldType);
	const commonProps: RendererProps = {
		error,
		errorMessage: attrInitialValueError,
		format: attrFormat,
		helperText: helperTextAttributeDefinitionHasInitialValue,
		label: labelInitialValue,
	};

	if (attrType === VALUE_TYPE.BOOLEAN) {
		commonProps.checked = attrInitialValue;
		commonProps.onChange = onChangeInitialValue;
	} else {
		commonProps.onBlurChange = onChangeInitialValue;
		commonProps.value = attrInitialValue;
	}

	return (
		<Component {...commonProps} />
	);
});

export default AttributeDefinitionSectionInitialValue;